import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import moment from "moment";
import { autoFitColumns } from "utils/DownloadExcel";
import { utils, writeFileXLSX } from "xlsx";
import { getEmpFullNameTHByEmpData } from "utils/HelperFunction";
import { useReportProductDoInitContext } from "contexts/reportProductDoPage/ReportProductDoInitContext";
export default function useExportReportProductDo() {
    var _useReportProductDoInitContext = useReportProductDoInitContext(), reportDate = _useReportProductDoInitContext.reportDate, userInfo = _useReportProductDoInitContext.userInfo, branchMultiSelected = _useReportProductDoInitContext.branchMultiSelected;
    var branchListMap = function(param) {
        var uml = param.uml, ums = param.ums, branches = param.branches;
        return branches.reduce(function(acc, b) {
            var branchName = "สาขา (".concat(b.dimMstBranch.branch_code, " ").concat(b.dimMstBranch.name, ")");
            acc["จำนวนขาย ".concat(branchName)] = "".concat(uml === null || uml === void 0 ? void 0 : uml.unit_name, " ").concat(b.sold_uml, " ").concat(ums === null || ums === void 0 ? void 0 : ums.unit_name, " ").concat(b.sold_ums);
            acc["UMS ".concat(branchName)] = b.sold_total_ums;
            acc["ยอดรวม EX.Vat ".concat(branchName)] = b.sum_total_price_before_vat;
            return acc;
        }, {});
    };
    function mappingExcelData(datas) {
        return datas.map(function(v, i) {
            var uml = v.uml, ums = v.ums;
            var branchDetail = branchListMap({
                uml: uml,
                ums: ums,
                branches: v.branches
            });
            return _object_spread({
                ลำดับที่: i + 1,
                รหัสสินค้า: v.sku,
                บาร์โค้ด: v.barcodes.join(", "),
                ชื่อสินค้า: v.name_th,
                MIN: v.min_avg_discount_before_vat,
                MAX: v.max_avg_discount_before_vat,
                "หน่วยใหญ่ UML": v.uml.ratio_unit
            }, branchDetail);
        });
    }
    function downloadExcel(datas, filename) {
        if (!Array.isArray(datas) || datas.length === 0) {
            console.warn("No data to export.");
            return;
        }
        var mappingData = mappingExcelData(datas);
        if (!mappingData || mappingData.length === 0) {
            console.warn("Mapping returned no data.");
            return;
        }
        var headerOffset = 1; // Start offset for header data
        var headerSpace = 5;
        var wb = utils.book_new();
        var ws = utils.json_to_sheet([]);
        ws["A".concat(headerOffset)] = {
            v: "รายงานยอดขายรายสินค้า จาก DO",
            t: "s"
        };
        ws["!merges"] = ws["!merges"] || [];
        ws["!merges"].push({
            s: {
                r: headerOffset - 1,
                c: 0
            },
            e: {
                r: headerOffset - 1,
                c: 3
            }
        });
        ws["A".concat(headerOffset + 1)] = {
            v: "จำนวนรายการ",
            t: "s"
        };
        ws["B".concat(headerOffset + 1)] = {
            v: "".concat(mappingData.length, " รายการ"),
            t: "s"
        };
        ws["F".concat(headerOffset + 1)] = {
            v: "ช่วงเวลาข้อมูล",
            t: "s"
        };
        ws["G".concat(headerOffset + 1)] = {
            v: "".concat(moment(reportDate.startDate).format("DD/MM/YYYY"), " - ").concat(moment(reportDate.endDate).format("DD/MM/YYYY")),
            t: "s"
        };
        ws["A".concat(headerOffset + 2)] = {
            v: "ผู้จัดทำ",
            t: "s"
        };
        ws["B".concat(headerOffset + 2)] = {
            v: getEmpFullNameTHByEmpData(userInfo === null || userInfo === void 0 ? void 0 : userInfo.dimNewAlldernowEmp),
            t: "s"
        };
        ws["F".concat(headerOffset + 2)] = {
            v: "เวลาดึงข้อมูล",
            t: "s"
        };
        ws["G".concat(headerOffset + 2)] = {
            v: moment().format("DD/MM/YYYY - hh:mm A"),
            t: "s"
        };
        ws["A".concat(headerOffset + 3)] = {
            v: "สาขา",
            t: "s"
        };
        ws["B".concat(headerOffset + 3)] = {
            v: branchMultiSelected.map(function(v) {
                return v.label;
            }).join(", "),
            t: "s"
        };
        utils.sheet_add_json(ws, mappingData, {
            origin: "A".concat(headerOffset + headerSpace)
        });
        ws["!cols"] = autoFitColumns(mappingData, ws);
        utils.book_append_sheet(wb, ws, filename);
        writeFileXLSX(wb, "".concat(filename, ".xlsx"));
    }
    return {
        downloadExcel: downloadExcel
    };
}
